import { getEncodedParams } from 'helpers/encodeParams';

exports.layerTwoSummaryEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/layer/2/summary?start=${encodedParams.start}&end=${encodedParams.end}`;
};

exports.layerTwoChannelSummaryEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/layer/2/${params.channel}/summary?start=${encodedParams.start}&end=${encodedParams.end}`;
};

exports.layerTwoActivityEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/layer/2/activities?start=${encodedParams.start}&end=${encodedParams.end}`;
};

exports.layerTwoSEMSummaryEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/layer/2/sem/summary?start=${encodedParams.start}&end=${encodedParams.end}`;
};



// WEBPACK FOOTER //
// ./src/services/layerTwo/selectors.js